import { ReceivedFileDTO } from "../DTO/receivedFileDTO";
import { Customer } from "./customer";

export class ReceivedFile{
    public id!: number;
    public name!: string;
    public customerId!: number;
    public customer!: Customer;
    public userId!: number;
    public interfaceType!: number; //0=manual upload, 1=sftp service, 2=externalservice, 3=email, 4=queued from other moov, 5=dropbox ... to be contiuned
    public sourceIP!: string;
    public status!: number; //1=processed, 2=Error:no moov config, 3=Error:multiple moov configs, 4=Error:inactive moov config, 5=Error:inactive customer, 6=Error:file does not match filedefinition
    public moovDefinitionId!: number;
    public moovDefinitionName!: string;
    public moovConfigurationId!: number;
    public moovInstanceId!: number;
    public filepath!: string;
    public added!: Date;
    public externalUploaderName!: string; //used for external file upload
    public externalUploaderEmail!: string; //used for external file upload
    public purgeAfter!: Date;
    public purgedAt!: Date;


    public static mapFromDTO(param:ReceivedFileDTO):ReceivedFile{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ReceivedFile();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.customerId = param.customerId;
            obj.userId = param.userId;
            obj.interfaceType = param.interfaceType;
            obj.sourceIP = param.sourceIP;
            obj.status = param.status;
            obj.moovDefinitionId = param.moovDefinitionId;
            obj.moovDefinitionName = param.moovDefinitionName;
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.moovInstanceId = param.moovInstanceId;
            obj.filepath = param.filepath;
            obj.added = new Date(param.added);
            obj.externalUploaderName  = param.externalUploaderName;
            obj.externalUploaderEmail = param.externalUploaderEmail;
            obj.purgeAfter = new Date(param.purgeAfter);
            if(param.purgedAt) obj.purgedAt = new Date(param.purgedAt);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ReceivedFile):ReceivedFileDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ReceivedFileDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.customerId = param.customerId;
            dto.userId = param.userId;
            dto.interfaceType = param.interfaceType;
            dto.sourceIP = param.sourceIP;
            dto.status = param.status;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.moovDefinitionName = param.moovDefinitionName;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.moovInstanceId = param.moovInstanceId;
            dto.filepath = param.filepath;
            dto.added = param.added.toISOString();
            dto.externalUploaderName = param.externalUploaderName;
            dto.externalUploaderEmail = param.externalUploaderEmail;
            dto.purgeAfter = param.purgeAfter.toISOString();
            if(param.purgedAt) dto.purgedAt = param.purgedAt.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 1:
                return "Processed";
            case 2:
                return "Error: no moov configuration found";
            case 3:
                return "Error: multiple moov configurations found";
            case 4:
                return "Error: inactive moov configuration";
            case 5:
                return "Error: inactive customer";
            case 6:
                return "Error: file does not match file definition";
            default:
                return "";
        }
    }

    get displayInterfaceType(){
        switch(this.interfaceType){
            case 0:
                return "Manual upload";
            case 1:
                return "SFTP upload";
            case 2:
                return "External API";
            case 3:
                return "Email";
            case 4:
                return "Queued from other moov";
            case 5:
                return "Dropbox";
            case 6:
                return "SFTP pull";
            default:
                return "";
        }
    }

    get statusColor(){
        if(this.status==1) return "black";
        else return "red";
    }
}